
import { set, toggle } from '@/utils/vuex'
import { generateRegistrationID } from '@/utils/helper'

export default {
}
